export default __webpack_public_path__ + "static/affirmational-perfect-b7eb4b9a6a07ba6383993f12e84366ec.svg";